// Маска российского мобильного номера: +7 (937) 495-4422

// Цифры номера с кодом страны 7 (максимум 11). 8XXXXXXXXXX -> 7XXXXXXXXXX, 9XXXXXXXXX -> 79XXXXXXXXX
export const extractDigits = (value) => {
  let digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits[0] === '8') digits = '7' + digits.slice(1);
  else if (digits[0] !== '7') digits = '7' + digits;
  return digits.slice(0, 11);
};

// Прогрессивное форматирование: разделители добавляются только перед следующей цифрой
export const formatPhone = (digits) => {
  const national = digits.slice(1, 11);
  if (!national) return '';
  let result = '+7 (' + national.slice(0, 3);
  if (national.length > 3) result += ') ' + national.slice(3, 6);
  if (national.length > 6) result += '-' + national.slice(6, 10);
  return result;
};

export const maskPhone = (value) => formatPhone(extractDigits(value));

export const isCompletePhone = (value) => extractDigits(value).length === 11;

export const toE164 = (value) => (isCompletePhone(value) ? '+' + extractDigits(value) : '');
